/**
 * Almari lifestyle-connectors barrel. Exposes the subset relevant to closet
 * (orders + photos + occasion-context). The other 5 lifestyle connectors
 * live in the canonical chassis and may surface in Almari v1.1.
 */
export type {
  ConnectorId,
  ConnectorPurpose,
  ConnectorState,
  ConnectMeta,
  Connector,
  ConsentReceipt,
  Mode,
  Status,
  Paise,
  Provenance,
  WardrobeOrderItem,
  TripRecord,
  TravelBooking,
  FoodOrder,
  PhotoSlim,
} from './types.ts';
export { paise } from './types.ts';

export { GmailOAuth, GOOGLE_SCOPES, ensureFreshToken, gmailFetch } from './gmail-oauth.ts';
export type { OAuthToken, OAuthMode, GmailOAuthOpts } from './gmail-oauth.ts';

export { fetchOrders as fetchGmailOrders, parseMerchantMessage } from './gmail-orders.ts';
export { fetchClosetPhotos } from './gphotos-readonly.ts';
export { fetchFoodOrders } from './zomato-swiggy-parser.ts';
export { fetchTrips } from './uber-ola-parser.ts';
export { fetchTravel } from './mmt-travel-parser.ts';

import type { ConnectMeta } from './types.ts';

export const ALMARI_CONNECTORS: readonly ConnectMeta[] = [
  {
    id: 'gmail-orders',
    title_en: 'Gmail orders',
    title_hi: 'जीमेल ऑर्डर',
    description: 'Auto-imports your last 2 years of Myntra, Ajio, Amazon, Nykaa, Tata-Cliq and Meesho orders into the wardrobe.',
    purposes: ['wardrobe.auto_import', 'wardrobe.wishlist_seed'],
    scopes: ['https://www.googleapis.com/auth/gmail.readonly'],
    retention_days: 365,
    mode_default: 'mock',
    v0_status: 'mock_only',
  },
  {
    id: 'gphotos',
    title_en: 'Google Photos',
    title_hi: 'गूगल फ़ोटो',
    description: 'Indexes garment photos from your Closet album. Pixels stay on the device; only embeddings persist.',
    purposes: ['wardrobe.auto_import'],
    scopes: ['https://www.googleapis.com/auth/photoslibrary.readonly'],
    retention_days: 730,
    mode_default: 'mock',
    v0_status: 'mock_only',
  },
  {
    id: 'mmt-travel',
    title_en: 'MakeMyTrip + IRCTC',
    title_hi: 'यात्रा',
    description: 'Upcoming destinations seed vacation-wear suggestions.',
    purposes: ['lifestyle.context_signal'],
    scopes: ['https://www.googleapis.com/auth/gmail.readonly'],
    retention_days: 365,
    mode_default: 'mock',
    v0_status: 'mock_only',
  },
  {
    id: 'zomato-swiggy',
    title_en: 'Zomato + Swiggy',
    title_hi: 'खाना',
    description: 'Late-night vs lunch order cadence cross-codes outfit occasion mix.',
    purposes: ['lifestyle.context_signal'],
    scopes: ['https://www.googleapis.com/auth/gmail.readonly'],
    retention_days: 180,
    mode_default: 'mock',
    v0_status: 'mock_only',
  },
  {
    id: 'uber-ola',
    title_en: 'Uber + Ola',
    title_hi: 'राइड्स',
    description: 'Airport rides and weekend pickups hint at evening-wear vs travel-wear demand.',
    purposes: ['lifestyle.context_signal'],
    scopes: ['https://www.googleapis.com/auth/gmail.readonly'],
    retention_days: 365,
    mode_default: 'mock',
    v0_status: 'mock_only',
  },
];
